import React from 'react';

import { TalkToJourneyMessage } from './types';
import { Block, LayoutMode, LinkBlockContent, PdfBlockContent, Section, VideoBlockContent } from '../types';
import classNames from 'classnames';
import { ChevronRightRegularIcon } from 'src/monet/icons';

export const TalkToJourneySourceBlock = ({
  message,
  onSourceClick,
  layoutMode,
  findBlockByContentUuid,
  findSectionById,
}: {
  message: TalkToJourneyMessage
  onSourceClick?: () => void;
  layoutMode: LayoutMode;
  findBlockByContentUuid: (content_uuid: string) => Block | null;
  findSectionById: (section_id: string) => Section | null;
}) => {
  if (!message.source_content_uuid && !message.source_node_uuid) return null;

  const block = message.source_content_uuid ? findBlockByContentUuid(message.source_content_uuid) : null;
  const section = message.source_node_uuid ? findSectionById(message.source_node_uuid) : null;

  if (!block && !section) return null;

  const renderSourceBlock = (block: Block) => {
    if (!block) return null;

    const { content } = block;
    const { type } = content;

    if (type === 'link') {
      const { link } = content as LinkBlockContent;
      return (
        <div>Source: {link.title || link.url}</div>
      )
    } else if (type === 'pdf') {
      const { metadata } = content as PdfBlockContent;
      return (
        <div>Source: PDF</div>
      )
    } else if (type === 'video') {
      const { metadata } = content as VideoBlockContent;

      return (
        <div>Source: Video</div>
      )
    }
    return null;
  }

  const sourceBlockHTML = block ? renderSourceBlock(block) : <div>Source: {section?.name}</div>;

  if (!sourceBlockHTML) return null;

  return (
    <div className="flex items-start">
      <button type='button' className={'flex underline hover:opacity-80'}
        onClick={onSourceClick}>
        <div className="text-left">{sourceBlockHTML}</div>
      </button>
    </div>
  )
}